import "./header.css";
import React, {useCallback, useContext} from "react";
import {Link} from 'react-router-dom';
import {LogInState, Role} from "../Utils/enums";
import {LoggedInContext} from "../Utils/contexts";
import {logOut} from "../Utils/queries";

const Header = ({setRole, setUserId}: {setRole: React.Dispatch<React.SetStateAction<Role>>|undefined, setUserId: React.Dispatch<React.SetStateAction<Role>>|undefined}) => {
    const logInHandler = useContext(LoggedInContext)!;

    const logOutCallback = useCallback(async () => {
        setRole!(Role.Unknown);
        setUserId!(0);
        await logOut();
        logInHandler(LogInState.NotLoggedIn);
    }, [logInHandler, setRole, setUserId]);
    
    return (
        <header>
            <div id="logo">
                <Link style={{textDecoration: "unset"}} to="/">
                    <img src="/logo512.png" alt="MapID" style={{height:50}}/>
                </Link>
            </div>
            <div className="header-buttons">
                <button id="logoutBtn" onClick={logOutCallback}>Log Out</button>
            </div>
        </header>
    );
};

export default Header;